import { defaultPost } from '@bikemap/js/utility'
import { gettext, modals, notifications } from '@bikemap/js/services'

function handleRemoveRouteConfirm(e, modal) {
    modal.setLoading()
    const sortableList = document.getElementById('collection-items-sortable')
    const body = new FormData
    body.append('routeId', modal.referrer.dataset.routeId)

    defaultPost(sortableList.dataset.deleteRouteUrl, body)
        .then(res => {
            if (res.success) {
                // TODO: Find a clearer implementation with new tiles
                $(modal.referrer).parents('li').remove()
                if (sortableList.children.length) {
                    const counters = sortableList.querySelectorAll('.tile-collection-counter')
                    for (let i = 0; i < counters.length; i++) {
                        counters[i].textContent = '' + i + 1
                    }
                } else {
                    const parent = /** @type {HTMLElement} */ (sortableList.parentNode)
                    parent.innerHTML = (
                        '<p class="text-secondary">' +
                            gettext('No routes added to this collection yet.') +
                        '</p>'
                    )
                }
            } else {
                notifications.error(res.error || gettext("Couldn't remove route from collection."))
            }
        })
        .catch(res => notifications.error(res.statusText))
        .finally(() => {
            modal.setLoading(false)
            modals.close()
        })
}

export function initRemoveRouteButtons() {
    const deleteButtons = document.querySelectorAll('.collection-route-delete')
    for (let i = 0; i < deleteButtons.length; i++) {
        deleteButtons[i].addEventListener('click', e => {
            e.preventDefault()
            modals.show('remove-route', {
                title: gettext('Remove route'),
                message: gettext('Do you really want to delete this route from the collection?'),
                buttons: [
                    { content: gettext('Cancel'), action: 'close' },
                    { content: gettext('Confirm'), style: 'danger', action: 'submit' },
                ],
                onSubmit: handleRemoveRouteConfirm,
                referrer: deleteButtons[i],
            })
        })
    }
}
